// frontend/src/design-system/components/NoiseOverlay.tsx
import * as React from 'react';

/**
 * SVG noise overlay — adds tactile grain at very low opacity.
 * Sits above the mesh background but below all interactive surfaces.
 */
export function NoiseOverlay() {
  return (
    <svg
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 h-full w-full opacity-[0.025] mix-blend-overlay"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="noiseFilter">
        <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch" />
        <feColorMatrix type="saturate" values="0" />
      </filter>
      <rect width="100%" height="100%" filter="url(#noiseFilter)" />
    </svg>
  );
}
